import { FieldTypes } from '../../types/fieldTypes.ts';
import type { Fields } from '../../types/index.ts';
import { yesNoOptions as options } from './options.ts';

// https://www.gdsuite.it/laravel/v1/visita/data?pk_id_pt=37392&pk_id_vt=26030&group=400
export const step4: Fields = [
  {
    code: 401,
    name: 'Allergia Uova',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
  {
    code: 402,
    name: 'Allergia Fragole',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
  {
    code: 403,
    name: 'Allergia Frutta secca',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
  {
    code: 404,
    name: 'Allergie Crostacei',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
  {
    code: 405,
    name: 'Allergia Molluschi',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
  {
    code: 406,
    name: 'Allergia Pesce',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
  {
    code: 407,
    name: 'Allergia Soya',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
  {
    code: 408,
    name: 'Allergia Kiwi',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
  {
    code: 409,
    name: 'Allergia Proteine del latte',
    type: FieldTypes.radio,
    options,
    group: 400,
  },
];
